/**
 * Icon system using react-icons
 * Maps semantic names to actual icon components from react-icons
 */

// Tabler Icons - Best for wine/operations
import {
  TbLeaf,
  TbFlask2,
  TbGlassFull,
  TbBottle,
  TbFilter,
  TbFilterFilled,
  TbRotate,
  TbArrowBackUp,
  TbScissors,
  TbArrowsShuffle,
  TbDroplet,
  TbSearch,
  TbX,
  TbMenu,
  TbChevronDown,
  TbChevronUp,
  TbChevronsDown,
  TbChevronsUp,
  TbCalendar,
  TbCalendarCheck,
  TbSettings,
  TbLayout,
  TbQrcode,
  TbCheck,
  TbTag,
  TbTags,
  TbCopy,
  TbNotes,
  TbBuildingWarehouse,
  TbAlertTriangle,
  TbEye,
  TbEyeOff,
  TbClock,
  TbMinus,
  TbPlus,
  TbSparkles,
  TbBook,
  TbPrinter,
  TbFileSpreadsheet,
  TbDownload,
  TbLink,
  TbArrowsSort,
  TbCircle,
  TbCircleFilled,
  TbPencil,
  TbTrash,
  TbExternalLink,
  TbUser,
  TbUsers,
  TbMap,
  TbSpray,
  TbThermometer,
  TbCloud,
  TbCloudRain,
  TbSun,
  TbTruck,
  TbCertificate,
  TbStarFilled,
  TbHourglassHigh,
  TbPercentage,
  TbMicroscope,
  TbTestPipe,
  TbPlant,
  TbArrowRight,
  TbArrowLeft,
  TbFolderOpen,
  TbBrandGithub,
  TbReload,
  TbLoader,
  TbWorldWww,
  TbChevronRight,
  TbChevronLeft,
  TbChevronsRight,
  TbFileText,
  TbInfoCircle,
  TbHome,
  TbLogout,
  TbBell,
  TbShoppingCart,
  TbHistory,
  TbGraph,
  TbDeviceFloppy,
  TbPlayerPlay,
  TbArrowsDiagonalMinimize2,
  TbArrowsDiagonal,
  TbCurrencyEuro,
  TbCurrencyDollar,
  TbCurrencyPound,
  TbCurrencyRupee,
  TbRobot,
  TbBarrel,
  TbBread,
  TbMail,
  TbUserPlus,
  TbSpy,
  TbSend,
  TbBan,
  TbAlertCircle,
  TbCircleCheck,
  TbCircleX,
  TbArchive,
  TbArrowUp,
  TbArrowDown,
  TbFileUnknown,
  TbFileImport,
  TbNote,
  TbArrowBarToDown,
} from "react-icons/tb";

/**
 * Operation type icons
 */
export const operationIcons = {
  DESTEMMING: TbLeaf,
  RACKING: TbRotate,
  CUT: TbScissors,
  TRANSFER: TbArrowsShuffle,
  BOTTLING: TbBottle,
  FILTERING: TbFilter,
  WINEMAKING: TbGlassFull,
  DECANT: TbDroplet,
  OUILLAGE: TbBarrel,
};

/**
 * State/stage icons
 */
export const stateIcons = {
  GRAPE: TbLeaf,
  MUST: TbFlask2,
  WINE: TbGlassFull,
  BOTTLED: TbBottle,
};

/**
 * Generic UI icons
 */
export const uiIcons = {
  search: TbSearch,
  remove: TbX,
  close: TbX,
  menu: TbMenu,
  chevronDown: TbChevronDown,
  chevronUp: TbChevronUp,
  chevronsDown: TbChevronsDown,
  chevronsUp: TbChevronsUp,
  chevronRight: TbChevronRight,
  chevronLeft: TbChevronLeft,
  chevronsRight: TbChevronsRight,
  calendar: TbCalendar,
  calendarCheck: TbCalendarCheck,
  settings: TbSettings,
  gear: TbSettings,
  qrcode: TbQrcode,
  check: TbCheck,
  checkCircle: TbCheck,
  tag: TbTag,
  tags: TbTags,
  clone: TbCopy,
  copy: TbCopy,
  notes: TbNotes,
  warehouse: TbBuildingWarehouse,
  alert: TbAlertTriangle,
  warning: TbAlertTriangle,
  eye: TbEye,
  eyeSlash: TbEyeOff,
  clock: TbClock,
  minus: TbMinus,
  plus: TbPlus,
  book: TbBook,
  print: TbPrinter,
  fileExcel: TbFileSpreadsheet,
  download: TbDownload,
  link: TbLink,
  externalLink: TbExternalLink,
  sort: TbArrowsSort,
  dotCircle: TbCircleFilled,
  edit: TbPencil,
  delete: TbTrash,
  trash: TbTrash,
  user: TbUser,
  users: TbUsers,
  map: TbMap,
  mapPin: TbMap,
  spraycan: TbSpray,
  temperature: TbThermometer,
  sun: TbSun,
  cloud: TbCloud,
  cloudRain: TbCloudRain,
  truck: TbTruck,
  certificate: TbCertificate,
  star: TbStarFilled,
  hourglass: TbHourglassHigh,
  percent: TbPercentage,
  microscope: TbMicroscope,
  vial: TbTestPipe,
  seedling: TbPlant,
  leaf: TbLeaf,
  arrowRight: TbArrowRight,
  arrowLeft: TbArrowLeft,
  arrowRightArrowLeft: TbArrowsShuffle,
  arrowsRotate: TbRotate,
  folderTree: TbFolderOpen,
  code: TbBrandGithub,
  refresh: TbReload,
  recycle: TbReload,
  spinner: TbLoader,
  loader: TbLoader,
  display: TbWorldWww,
  globe: TbWorldWww,
  fileAlt: TbFileText,
  file: TbFileText,
  infoCircle: TbInfoCircle,
  info: TbInfoCircle,
  home: TbHome,
  logout: TbLogout,
  bell: TbBell,
  shoppingCart: TbShoppingCart,
  history: TbHistory,
  chart: TbGraph,
  snowflake: TbSparkles, // approximation for snowflake
  soap: TbDroplet, // approximation for soap
  spa: TbLeaf, // approximation for spa
  droplet: TbDroplet,
  triangle: TbAlertTriangle,
  eurSign: TbCurrencyEuro,
  dollarSign: TbCurrencyDollar,
  poundSign: TbCurrencyPound,
  rupeeSign: TbCurrencyRupee,
  bezierCurve: TbPencil, // approximation
  sliders: TbSettings, // approximation
  hand: TbUser, // approximation
  scroll: TbFileText, // approximation
  sitemap: TbLayout,
  layerGroup: TbLayout,
  diagramProject: TbLayout,
  codeBranch: TbBrandGithub,
  timelineIcon: TbHistory,
  cubesStacked: TbLayout,
  tabletIcon: TbDroplet,
  prescriptionBottle: TbFlask2,
  userGear: TbSettings,
  flexColumn: TbLayout,
  arrowDown: TbChevronDown,
  tentArrow: TbArrowRight,
  eyeDropper: TbDroplet,
  calendarDay: TbCalendar,
  calendarPlus: TbCalendar,
  bars: TbMenu,
  xmark: TbX,
  circle: TbCircle,
  filterCircleXmark: TbFilter,
  anglesRight: TbChevronsRight,
  anglesLeft: TbChevronsRight,
};

/**
 * Helper function to render an icon by semantic name
 * @param {string} iconName - The semantic icon name
 * @param {object} props - Props to pass to the icon component
 * @returns {JSX.Element}
 */
export const Icon = ({ name, ...props }) => {
  // Try to find in operationIcons first
  let IconComponent = operationIcons[name];

  // Then try stateIcons
  if (!IconComponent) {
    IconComponent = stateIcons[name];
  }

  // Then try uiIcons
  if (!IconComponent) {
    IconComponent = uiIcons[name];
  }

  // Fallback to a default icon if not found
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in icon system`);
    IconComponent = TbCircle;
  }

  return <IconComponent {...props} />;
};

/**
 * Inline icon mapping for fast-icon strings
 * This maps fa-* style string names to icon components
 */
export const faIconMap = {
  // Operation icons
  "fa-leaf": TbLeaf,
  "fa-arrows-rotate": TbRotate,
  "fa-scissors": TbScissors,
  "fa-arrow-right-arrow-left": TbArrowsShuffle,
  "fa-wine-bottle": TbBottle,
  "fa-filter": TbFilterFilled,
  "fa-wine-glass": TbGlassFull,
  "fa-droplet": TbDroplet,

  // UI icons
  "fa-circle": TbCircleFilled,
  "fa-circle-dot": TbCircleFilled,
  "fa-external-link-alt": TbExternalLink,
  "fa-arrow-right": TbArrowRight,
  "fa-search": TbSearch,
  "fa-xmark": TbX,
  "fa-x": TbX,
  "fa-bars": TbMenu,
  "fa-angle-down": TbChevronDown,
  "fa-angle-up": TbChevronUp,
  "fa-angles-down": TbChevronsDown,
  "fa-angles-up": TbChevronsUp,
  "fa-chevron-right": TbChevronRight,
  "fa-chevron-left": TbChevronLeft,
  "fa-chevrons-right": TbChevronsRight,
  "fa-calendar": TbCalendar,
  "fa-calendar-check": TbCalendarCheck,
  "fa-user-gear": TbSettings,
  "fa-user": TbUser,
  "fa-right-from-bracket": TbLogout,
  "fa-arrow-left": TbArrowLeft,
  "fa-book": TbBook,
  "fa-print": TbPrinter,
  "fa-file-excel": TbFileSpreadsheet,
  "fa-file-arrow-down": TbDownload,
  "fa-box": TbLayout,
  "fa-plus": TbPlus,
  "fa-filter-circle-xmark": TbFilterFilled,
  "fa-angles-right": TbChevronsRight,
  "fa-calendar-plus": TbCalendar,
  "fa-link": TbLink,
  "fa-sort": TbArrowsSort,
  "fa-sort-up": TbChevronUp,
  "fa-sort-down": TbChevronDown,
  "fa-qrcode": TbQrcode,
  "fa-display": TbWorldWww,
  "fa-folder-tree": TbFolderOpen,
  "fa-check": TbCheck,
  "fa-tag": TbTag,
  "fa-tags": TbTags,
  "fa-clone": TbCopy,
  "fa-note-sticky": TbNotes,
  "fa-warehouse": TbBuildingWarehouse,
  "fa-triangle-exclamation": TbAlertTriangle,
  "fa-eye": TbEye,
  "fa-eye-slash": TbEyeOff,
  "fa-up-right-from-square": TbExternalLink,
  "fa-euro-sign": TbCurrencyEuro,
  "fa-dollar-sign": TbCurrencyDollar,
  "fa-pound-sign": TbCurrencyPound,
  "fa-rupee-sign": TbCurrencyRupee,
  "fa-spinner": TbLoader,
  "fa-clock": TbClock,
  "fa-layer-group": TbLayout,
  "fa-minus": TbMinus,
  "fa-recycle": TbReload,
  "fa-snowflake": TbSparkles,
  "fa-bezier-curve": TbPencil,
  "fa-sliders": TbSettings,
  "fa-soap": TbDroplet,
  "fa-flask": TbFlask2,
  "fa-star": TbStarFilled,
  "fa-certificate": TbCertificate,
  "fa-spa": TbLeaf,
  "fa-cloud-sun": TbCloud,
  "fa-sun": TbSun,
  "fa-temperature-half": TbThermometer,
  "fa-cloud-rain": TbCloudRain,
  "fa-truck": TbTruck,
  "fa-temperature-low": TbThermometer,
  "fa-heart-pulse": TbSparkles,
  "fa-check-circle": TbCheck,
  "fa-percent": TbPercentage,
  "fa-microscope": TbMicroscope,
  "fa-vial": TbTestPipe,
  "fa-seedling": TbPlant,
  "fa-file-alt": TbFileText,
  "fa-map-pin": TbMap,
  "fa-spray-can": TbSpray,
  "fa-diagram-project": TbLayout,
  "fa-code-branch": TbBrandGithub,
  "fa-hourglass-half": TbHourglassHigh,
  "fa-scroll": TbFileText,
  "fa-code": TbBrandGithub,
  "fa-remove": TbX,
  "fa-flask-vial": TbFlask2,
  "fa-prescription-bottle": TbFlask2,
  "fa-circle-info": TbInfoCircle,
  "fa-tablets": TbLayout,
  "fa-cubes-stacked": TbLayout,
  "fa-gear": TbSettings,
  "fa-sitemap": TbLayout,
  "fa-calendar-day": TbCalendar,
  "fa-eye-dropper": TbDroplet,
  "fa-timeline": TbHistory,
  "fa-pen": TbPencil,
  "fa-bread-slice": TbBread,
  "fa-hand": TbUser,
  "fa-group-arrows-rotate": TbRotate,
  "fa-arrows-minimize": TbArrowsDiagonalMinimize2,
  "fa-arrows-maximize": TbArrowsDiagonal,
  "fa-pencil": TbPencil,
  "fa-trash": TbTrash,
  "fa-device-floppy": TbDeviceFloppy,
  "fa-rotate": TbRotate,
  "fa-rotate-left": TbArrowBackUp,
  "fa-check-double": TbCheck,
  "fa-file-lines": TbFileText,
  "fa-play": TbPlayerPlay,
  "fa-wand-magic-sparkles": TbSparkles,
  "fa-clock-rotate-left": TbHistory,
  "fa-robot": TbRobot,
  "fa-envelope": TbMail,
  "fa-user-plus": TbUserPlus,
  "fa-user-secret": TbSpy,
  "fa-paper-plane": TbSend,
  "fa-ban": TbBan,
  "fa-bell": TbBell,
  "fa-circle-exclamation": TbAlertCircle,
  "fa-exclamation-circle": TbAlertCircle,
  "fa-circle-check": TbCircleCheck,
  "fa-circle-xmark": TbCircleX,
  "fa-calendar-days": TbCalendar,
  "fa-box-archive": TbArchive,
  "fa-arrow-up": TbArrowUp,
  "fa-arrow-down": TbArrowDown,
  "fa-play-circle": TbPlayerPlay,
  "fa-file-circle-question": TbFileUnknown,
  "fa-file-import": TbFileImport,
  "fa-sticky-note": TbNote,
  "fa-tent-arrow-down-to-line": TbArrowBarToDown,
};

/**
 * Get icon component from fa-* style string
 * @param {string} faIconString - Icon name in fa-* format
 * @returns {React.ComponentType}
 */
export const getFaIcon = (faIconString) => {
  if (!faIconString) return TbCircleFilled;
  return faIconMap[faIconString] || TbCircleFilled;
};

export default {
  operationIcons,
  stateIcons,
  uiIcons,
  Icon,
  faIconMap,
  getFaIcon,
};
